module.exports = __webpack_public_path__ + "img/clock-orange.dcdceadb.svg";